export const ids = {
    TILE_PREFIX: 'tile-',
}

export const classNames = {
    BAD_NETWORK_CONTAINER: 'bad-network-indicator',
}
